export default "__VITE_ASSET__3ff8e3dc__"